const notificationTypes = {
	more_info: 'More information',

	note_text: 'Note',
	note_title: 'New note',

	lostpassword_text: 'Password request',
	lostpassword_title: 'Password request sent to',

	welcome_text: 'Welcome email',
	welcome_title: 'Welcome email sent to',

	message_text: 'Message received',
	message_title: 'Message received from',

	messagedone_text: 'Message processed',
	messagedone_title: 'Message processed',
	messagedone_name: '@:notificationTypes.more_info',

	damagereport_text: 'Damage report',
	damagereport_title: 'Damage report received from',

	meterleveldaily_text: 'Meter readings to be released',
	meterleveldaily_title: 'Meter readings to be released',
	meterleveldaily_name: 'Click here to release them',

	documentuser_text: 'New documents',
	documentuser_title: 'New documents',
	documentuser_name: 'Show documents',

	syncstatus_text: 'Data update',
	syncstatus_title: 'Data has been updated',
	syncstatus_name: '@:notificationTypes.more_info',

	quotaexceeded_text: 'Storage limit exceeded',
	quotaexceeded_title: 'Maximum storage reached or exceeded',
	quotaexceeded_name: 'Request extension',

	meterlevelrejected_text: 'Meter reading rejected',
	meterlevelrejected_title: 'Meter reading rejected',

	handoverinvitation_text: 'Handover protocol invitation',
	handoverinvitation_title: 'Invitation to a handover',
	handoverinvitation_name: 'Please check your emails',

	personupdate_text: 'A data change request is available',
	personupdate_title: 'Data change request sent',
	personupdate_name: 'To account',

	personupdateadmin_text: 'A data change request has been created',
	personupdateadmin_title: 'New data change request',
	personupdateadmin_name: 'Process request',

	consumptionnotification_text: 'New consumption information',
	consumptionnotification_title: 'New consumption information',
	consumptionnotification_name: 'Show consumption information',

	privacytosrejected_text: 'Terms of use rejected',
	privacytosrejected_title: 'Terms of use rejected',
	privacytosrejected_name: '@:notificationTypes.more_info',

	tickethistory_text: 'Data changes to your ticket are available',
	tickethistory_title: 'Data changes to your ticket are available',
	tickethistory_name: '@:notificationTypes.more_info',

	reviewdocument_title: 'Document review',
	reviewdocument_name: '@:notificationTypes.more_info',

	reportnotification_title: 'Report',
	reportnotification_text: 'Data changes to your report are available',
}

export default notificationTypes
